import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

/**
 * Stacking sections: each section pins and the next one scrolls over it.
 *
 * - Sections that fit the viewport: pin when top hits top, hold for section height.
 * - Sections taller than viewport: let user scroll through all content first,
 *   then pin when the bottom of the section reaches the bottom of the viewport.
 *   This ensures all content is visible before the next section covers it.
 */
export function setupStackingSections(selector = ".gsap-stack") {
  const stackSections = gsap.utils.toArray<HTMLElement>(selector);

  const getSectionMetrics = (section: HTMLElement) => {
    const viewportHeight = window.innerHeight;
    const sectionHeight = Math.max(section.offsetHeight, section.scrollHeight);
    const fitsViewport = sectionHeight <= viewportHeight * 1.05;

    return { viewportHeight, sectionHeight, fitsViewport };
  };

  stackSections.forEach((section, index) => {
    if (index >= stackSections.length - 1) return;

    ScrollTrigger.create({
      trigger: section,
      start: () => {
        const { fitsViewport } = getSectionMetrics(section);
        return fitsViewport ? "top top" : "bottom bottom";
      },
      end: () => {
        const { sectionHeight, viewportHeight, fitsViewport } = getSectionMetrics(section);
        return `+=${fitsViewport ? sectionHeight : viewportHeight}`;
      },
      pin: true,
      pinSpacing: false,
      invalidateOnRefresh: true,
      refreshPriority: index,
    });
  });
}
